module.exports = __webpack_public_path__ + "img/user-minus-02.affbb27f.svg";